import env from 'utils/env';
import request from './request';
import requestJson from './requestJson';

export function uploadProductsToCampaignCSV(id, csvData) {
  const requestUrl = `${env.aceApi}/1/campaigns/${id}/products/bulk-update/files`;
  return request(requestUrl, 'POST', {}, csvData);
}

export function uploadSkusToCampaignCSV(id, csvData) {
  const requestUrl = `${env.aceApi}/1/campaigns/${id}/skus/files`;
  return request(requestUrl, 'POST', {}, csvData);
}

export const updateCartsCSV = (csvData, isRemove) => {
  return requestJson(
    `${env.aceApi}/1/carts/bulk-addons/files?isRemove=${isRemove}`,
    'POST',
    null,
    csvData
  );
};

export const updateRefillsCartsCSV = (csvData, isRemove) => {
  const headers = { Accept: 'application/vnd.fabfitfun.v1+json' };
  return requestJson(
    `${env.refillsApi}/admin/subscriptions?isRemove=${isRemove}`,
    'POST',
    headers,
    csvData
  );
};

export const updateDiscountsCSV = (csvData) => {
  const requestUrl = `${env.aceApi}/1/admin/discounts/bulk-edit`;
  return request(requestUrl, 'POST', {}, csvData);
};

export const updateVariantDescriptorsCSV = (csvData) => {
  const requestUrl = `${env.aceApi}/1/admin/products/variants/variant-descriptors/bulk-update`;
  return request(requestUrl, 'POST', {}, csvData);
};

export const createProductsCSV = (csvData) => {
  const requestUrl = `${env.aceApi}/1/admin/products/bulk-create`;
  return request(requestUrl, 'POST', {}, csvData);
};

export const editProductsCSV = (csvData) => {
  const requestUrl = `${env.aceApi}/1/admin/products/bulk-edit`;
  return request(requestUrl, 'POST', {}, csvData);
};
